import React, { useCallback, useState } from "react";
import { HiOutlinePlus } from "react-icons/hi";
import CreateCollectionModal from "./CreateCollectionModal";
import AddToCollectionModal from "./AddToCollectionModal";
import { useAllSwingCollectionsByUserId } from "../../../../swingCollections/hooks/useAllSwingCollectionsByUserId";
import { LOCKED_COLUMN_COUNT } from "../constants/lockedColumnCount";
import { TbTablePlus } from "react-icons/tb";
import { useSwingLibraryStore } from "../../../store/swingLibraryStore";
import { useHistory } from "react-router-dom";
import Button from "../../../../../components/shared/Button/Button";

export function CollectionsRow({ columnsLength, selectedTableData }) {
  const {
    resetRowSelection,
    resetSelectedVideos,
    setQuickCompareCollection1,
    setQuickCompareCollection2,
    quickCompareCollection1,
  } = useSwingLibraryStore();

  const history = useHistory();

  const buildTempCollection = useCallback(
    ({ id, name, videos }) => ({
      id,
      collectionName: name,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      userId: "temp-user",
      videoIds: videos.map((v) => v.id),
    }),
    []
  );

  const handleQuickCompare = useCallback(() => {
    if (!selectedTableData || selectedTableData.length === 0) return;

    const tempCollection1 = buildTempCollection({
      id: "temp-collection-1",
      name: "Group 1",
      videos: selectedTableData,
    });

    setQuickCompareCollection1(tempCollection1);
    setQuickCompareCollection2(null);
    resetRowSelection();
    resetSelectedVideos();
  }, [
    buildTempCollection,
    resetRowSelection,
    resetSelectedVideos,
    selectedTableData,
    setQuickCompareCollection1,
    setQuickCompareCollection2,
  ]);

  const handleCreateAndCompare = useCallback(() => {
    if (
      !quickCompareCollection1 ||
      !selectedTableData ||
      selectedTableData.length === 0
    ) {
      return;
    }

    const tempCollection2 = buildTempCollection({
      id: "temp-collection-2",
      name: "Group 2",
      videos: selectedTableData,
    });

    setQuickCompareCollection2(tempCollection2);

    history.push("/compare", {
      tempCollections: [quickCompareCollection1, tempCollection2],
    });

    resetRowSelection();
    resetSelectedVideos();
    setQuickCompareCollection1(null);
    setQuickCompareCollection2(null);
  }, [
    buildTempCollection,
    history,
    quickCompareCollection1,
    resetRowSelection,
    resetSelectedVideos,
    selectedTableData,
    setQuickCompareCollection1,
    setQuickCompareCollection2,
  ]);

  const { collections } = useAllSwingCollectionsByUserId();
  const [isModalOpen, setModalOpen] = useState(false);
  const [isAddToCollectionModalOpen, setAddToCollectionModalOpen] =
    useState(false);

  return (
    <>
      <tr
        className="bg-primary50 border-collapse"
        style={{
          height: "55px",
        }}
      >
        <td className="px-2 text-start" colSpan={LOCKED_COLUMN_COUNT}>
          <div className="text-primary700 text-sm font-semibold">
            {quickCompareCollection1
              ? "Select Swings for Second Group"
              : "Swings Selected"}{" "}
            ({selectedTableData.length})
          </div>
        </td>
        <td
          className="px-2 text-start"
          colSpan={columnsLength - LOCKED_COLUMN_COUNT}
        >
          <div className="flex flex-row items-center gap-6">
            {quickCompareCollection1 ? (
              <Button
                className="ml-auto"
                color="primary500"
                onClick={handleCreateAndCompare}
                disabled={selectedTableData.length === 0}
              >
                Create and Compare
              </Button>
            ) : (
              <>
                <div
                  className="text-primary700 hover:text-primary500 flex cursor-pointer items-center gap-1"
                  onClick={handleQuickCompare}
                >
                  <TbTablePlus className="size-5 min-w-5" />
                  <div className="text-sm font-semibold">Quick Compare</div>
                </div>

                <div
                  className="text-primary700 hover:text-primary500 flex cursor-pointer items-center gap-1"
                  onClick={() => setModalOpen(true)}
                >
                  <HiOutlinePlus className="size-5 min-w-5" />
                  <div className="text-sm font-semibold">Create Collection</div>
                </div>

                {collections && collections?.length > 0 && (
                  <div
                    className="text-primary700 hover:text-primary500 flex cursor-pointer items-center gap-1"
                    onClick={() => setAddToCollectionModalOpen(true)}
                  >
                    <HiOutlinePlus className="size-5 min-w-5" />
                    <div className="text-sm font-semibold">
                      Add to Existing Collection
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </td>
      </tr>

      <CreateCollectionModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        videoIds={selectedTableData.map((r) => r.id)}
      />

      <AddToCollectionModal
        isOpen={isAddToCollectionModalOpen}
        onClose={() => setAddToCollectionModalOpen(false)}
        videoIds={selectedTableData.map((r) => r.id)}
      />
    </>
  );
}

export default CollectionsRow;
